import type { Fields } from "@vuex-orm/core";
import { FileSlide } from "./ActionHierarchy";

export class ImageSlide extends FileSlide {
  public static entity = "imageSlides";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
      duration: this.number(5),
    };
  }

  public static get humanName(): string {
    return "Image Slide";
  }
}
